import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http_post, http_get, http_put } from "utils/axios";
import { removeCookie, setCookie } from "utils/cookies";
import { encryptData } from "utils/encryption";

const initialState = {
  user: {},
  authorize: false,
  sekolah: {},
  authData: {},
  loading: true,
};

export const login = createAsyncThunk(
  "user/login",
  async (data, { rejectWithValue }) => {
    try {
      return await http_post(`v2/login`, false, data);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const auth = createAsyncThunk(
  "user/auth",
  async (data, { rejectWithValue }) => {
    try {
      return await http_get(`education/siswa/me`, true, data);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const logout = createAsyncThunk(
  "user/logout",
  async (data, { rejectWithValue }) => {
    try {
      return await http_get(`v2/logout`, true, data);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const profile = createAsyncThunk(
  "user/profile",
  async (data, { rejectWithValue }) => {
    try {
      return await http_get(`education/siswa/profile`, true, data);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const profileSekolah = createAsyncThunk(
  "user/profileSekolah",
  async (data, { rejectWithValue }) => {
    try {
      return await http_get(`education/siswa/sekolah/profile`, true, data);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const ubahEmail = createAsyncThunk(
  "user/ubahEmail",
  async (data, { rejectWithValue }) => {
    try {
      return await http_put(`education/siswa/email`, true, data);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const ubahPassword = createAsyncThunk(
  "user/ubahPassword",
  async (data, { rejectWithValue }) => {
    try {
      return await http_post(`education/siswa/change-password`, true, data);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const hapusAkun = createAsyncThunk(
  "user/hapusAkun",
  async (data, { rejectWithValue }) => {
    try {
      return await http_put(`education/siswa/status`, true, data);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const changeFoto = createAsyncThunk(
  "user/changeFoto",
  async (data, { rejectWithValue }) => {
    try {
      return await http_put(`education/siswa/foto`, true, data);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const emailResetPassword = createAsyncThunk(
  "user/resetPassword",
  async (data, { rejectWithValue }) => {
    try {
      return await http_post(`education/siswa/forgot-password`, true, data);
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

const userReducer = createSlice({
  name: "user",
  initialState,
  reducers: {
    CHANGEUSERPROFILE: (state, action) => {
      state.user.url_foto_profile = action.payload.foto;
    },
    LOADING: (state, action) => {
      state.user.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.fulfilled, (state, action) => {
        const token = encryptData(action.payload.data.data.token_user);
        localStorage.setItem("token_siswa", token);
        setCookie("token_siswa", token);
        state.authorize = true;
      })
      .addCase(auth.fulfilled, (state, action) => {
        state.authData = action.payload.data.data;
        state.authorize = true;
        state.loading = false;
      })
      .addCase(auth.rejected, (state, action) => {
        localStorage.removeItem("token_siswa");
        removeCookie("token_siswa");
        state.authorize = false;
        state.loading = false;
      })
      .addCase(logout.fulfilled, (state, action) => {
        localStorage.removeItem("token_siswa");
        removeCookie("token_siswa");
        state.authorize = false;
        state.loading = true;
        state.user = {};
      })
      .addCase(profile.fulfilled, (state, action) => {
        state.user = action.payload.data.data;
      })
      .addCase(profileSekolah.fulfilled, (state, action) => {
        state.sekolah = action.payload.data.data;
      });
  },
});

export const { CHANGEUSERPROFILE, LOADING } = userReducer.actions;

export const selectUser = (state) => state.user.user;
export const selectSekolah = (state) => state.user.sekolah;
export const selectAuthorize = (state) => state.user.authorize;
export const selectAuthData = (state) => state.user.authData;
export const selectLoading = (state) => state.user.loading;

export default userReducer.reducer;
